// TabContent.jsx
import React from "react";
import { TabPanel } from "@headlessui/react";

const TabContent = ({ tab, addons, addAddon, removeAddon, OrderSummary, currentTab, orderNumber, pageContext, totalPrice }) => {
	//console.log("TAB", tab);

	const isConfirmationTab = currentTab === 2;
	//console.log("currentTab", currentTab)

	return (
		<TabPanel>
			<div className="flex flex-col gap-7 lg:flex-row lg:gap-24">
				<div className={`w-full ${!isConfirmationTab ? "lg:w-[70%]" : "lg:w-[580px] m-auto pt-7 lg:pt-12 px-4 lg:px-0"}`}>
					{tab.panelContent({ addons, addAddon, removeAddon, OrderSummary, orderNumber, pageContext, totalPrice })}
				</div>

				{!isConfirmationTab && (
					<div className="w-full lg:w-[30%] lg:min-w-[30%] pt-7 lg:pt-24">
						{OrderSummary}
					</div>
				)}
			</div>
		</TabPanel>
	);
};

export default TabContent;
